/**
 * Rollenrechte innerhalb einer Partie – gespiegelt vom Server.
 *
 * Die eigentliche Durchsetzung liegt in `games.controller.ts`; hier geht es
 * nur darum, dieselbe Regel schon vor dem Netzabruf anzuwenden, damit
 * gesperrte Rollen keinen Server-Fehler zu sehen bekommen, sondern die
 * Schaltfläche gar nicht erst bedienen können. Weicht diese Kopie vom Server
 * ab, bleibt sie die schwächere Prüfung – der Server hat immer das letzte
 * Wort.
 */
import type { GameRole } from './api';

/** Zeitsteuerung und Spielstände gehören dem Aufbau, nicht der Betreuung. */
export function canControlTime(role: GameRole | null): boolean {
  return role === 'ADMIN' || role === 'TECHNICIAN';
}

/** Welche Kommandos die Rolle Support ausführen darf – Spiegel von `isSupportCommand`. */
export function isSupportCommand(type: string): boolean {
  return type.startsWith('ticket/') || type.startsWith('customer/') || type.startsWith('contract/');
}

/** Darf diese Rolle das gegebene Kommando überhaupt versuchen? */
export function canRunCommand(role: GameRole | null, commandType: string): boolean {
  if (role === 'CUSTOMER') return false;
  if (role === 'SUPPORT') return isSupportCommand(commandType);
  return true;
}
